<template>
  <div class="terms-page">
<h2>利用規約</h2>
<dl>
<dt>定義</dt>
<dd>本利用規約において使用する用語は、次の各号に定める意味として用いるものとします。
<ol>
<li>「当社」とは、株式会社ザッパラスをいいます。</li>
<!-- <li>「AGARUTV」とは、当社が提供する動画形式の情報コンテンツサービス、又は「AGARUTV」の名称で提供するWEBサイト若しくははアプリケーションをいいます。</li> -->
<li>「占いフェス」とは、当社が提供するリアルイベントサービス、又は「占いフェス」の名称で提供するWEBサイトをいいます。</li>
<li>「占いTV」とは、当社が提供するコンテンツ販売サービス、又は「占いTV」の名称で提供するWEBサイトをいいます。</li>
<li>「超運ランキング」とは、当社が提供するランキング形式の占い情報コンテンツサービス、又は、「超運ランキング」　の名称で提供するWEBサイト（uranaitv.jp/choun_ranking/）をいいます。</li>
<li>「本サービス」とは、「占いTV」、「占いフェス」、「超運ランキング」及びこれらに関連したものとして当社が提供する全てのサービスをいいます。</li>
<li>「お客様」とは、会員登録の有無を問わず本サービスのすべての利用者をいいます。</li>
<li>「本規約」とは、お客様が本サービスを利用する際に適用される条件を定めるものとして、当社とお客様との間で取り交わされる各種規約（本利用規約を含みます）、提供条件、注意事項等をいいます。</li>
<li>「アカウント」とは、会員登録されたお客様を特定するための認証情報、又は会員として本サービスを利用するための権利をいいます。</li>
<li>「投稿データ」とは、お客様が本サービス上に投稿した画像、コメント等の情報をいいます。</li>
</ol>
</dd>
<dt>総則</dt>
<dd>本利用規約は、お客様が本サービスを利用されるにあたって適用される条件を定めるものです。</dd>
<dd>本サービスを利用される前に本利用規約を注意深くお読みください。本サービスを利用するためには、本利用規約に同意いただく必要があります。</dd>
<dd>当社は、本規約の一部として、別途「プライバシーポリシー」「クッキー（cookie）について」を定めております。本サービスをご利用のお客様はあわせてこれらもお読みください。なお、本利用規約とこれらの規定との間で矛盾が生じる場合には、特段の定めのない限りこれらの規定が優先されるものとします。</dd>
<dd>当社は、本規約を変更することがあります。当社は本規約に変更する場合には合理的な事前の通知を行い、変更点を確認する機会をお客様に提供します。</dd>
<dd>本規約の内容に同意いただけない場合は、本サービスのご利用をお控えください。本サービスのご利用の継続されることで、最新版の本規約に同意されたものとみなします。</dd>
<dt>本サービスのご利用について</dt>
<dd>本サービスの一部の機能は、ご利用のために会員登録をしていただく必要があります。</dd>
<dd>会員登録には、お客様の情報を、正確に入力いただく必要があります。</dd>
<dd>当社は、次の場合には会員登録のお申込みをお断りすることがあります。また、会員登録を完了した後にこれらに該当した場合には、当社は以後のお客様による本サービスのご利用を停止し、会員登録を取り消すことができます。これらの場合、当社はこれらの措置の理由をお知らせすることはいたしません。
<ul>
<li>会員登録の情報に虚偽又は不備のある入力をされた場合</li>
<li>お客様が複数の会員登録を行おうとした場合</li>
<li>過去に当社又は当社グループ企業が提供するサービスにおいて利用規約違反等を行った方であると当社が判断した場合</li>
<li>その他、当社が不適当又は不適切であると判断した場合</li>
</ul>
</dd>
<dt>アカウントについて</dt>
<dd>本サービスでは、アカウントの特定のため、お客様の指定するメールアドレスとお客様の設定されるパスワードとの組み合わせ、またはTwitterもしくはLINEのいずれかによる認証を行います。</dd>
<dd>本サービスのアカウントは共通です。会員登録を行ったお客様は、単一のアカウントで本サービスのすべての機能をご利用いただけます。</dd>
<dd>当社は、お客様のアカウントが使用された場合にお客様ご自身が使用したものとみなします。このため、お客様は本サービスのアカウントを第三者に知られないよう適切に管理し、定期的にパスワードの変更を行う等、本サービスを利用する情報端末の管理も含めてアカウントの盗用を防止する措置をその責任において行わなければなりません。第三者がお客様のアカウントを用いて本サービスを利用した場合であっても、当社はそれによりお客様に生じた損害及び不利益について一切責任を負わないものとします。</dd>
<dt>会員登録の解除について</dt>
<dd>お客様は、当社所定の手続きによって、いつでも会員登録を解除することができます。</dd>
<dd>理由を問わず、会員登録を解除された場合、登録されていたお客様のアカウントに紐づけられた投稿データ及び購入履歴の閲覧、一部の有料コンテンツ・機能の利用等は一切できません。</dd>
<dd>会員登録を解除された後に、再度会員登録をされた場合でも、以前のお客様のアカウントに紐づけられた投稿データ及び購入履歴、一部の有料コンテンツ・機能等を再び閲覧・利用等をすることはできません。</dd>
<dt>利用料金について</dt>
<dd>お客様は、本サービスにおいて有料のチケット・コンテンツ・機能等を購入する場合、別途当社が定める方法で利用料金を支払うものとします。</dd>
<dd>お客様が期限までに利用料金のお支払いをしなかった場合、お客様は当社に対し、年14.6%の割合による遅延損害金を支払わなければなりません。</dd>
<dt>知的財産権等</dt>
<dd>本サービスに関する知的財産権を含む一切の権利は当社又はその権利を有する第三者に帰属します。</dd>
<dt>投稿データについて</dt>
<dd>当社は、投稿データについて管理又は確認することはしません。したがって、投稿データの内容が正確であること、有用であること、適法であることの保証はしません。</dd>
<dd>投稿データの著作権はお客様に帰属します。ただし、お客様は当社に対し、投稿データを使用、複製、処理、改変、送信及び表示等する権利（第三者へ再許諾する権利を含みます）を無償かつ無期限で許諾していただきます。また、お客様は著作者人格権を行使しないものとします。</dd>
<dd>お客様は投稿データが第三者の権利を侵害しないこと、適法なものであることを当社に保証するものとします。</dd>
<dd>当社は、投稿データの保存はいたしません。</dd>
<dd>当社は、社会情勢、特定の個人や団体への影響を考慮し、当社が不適切だと判断した投稿データの削除その他の措置を講じることがあります。</dd>
<dt>権利義務の譲渡</dt>
<dd>お客様は、本サービス及び本規約の下でのいずれの権利義務及び地位を、第三者に譲渡することができません。</dd>
<dt>広告について</dt>
<dd>当社は、本サービスに当社又は第三者の提供する広告を掲載することができるものとします。</dd>
<dd>広告の内容、デザイン、広告の対象となる商品、広告主等、広告に関する事項は当社の判断により決定いたします。</dd>
<dt>お客様の個人情報の取扱について</dt>
<dd>ご提供いただき当社が取得したお客様の個人情報は、別途記載するプライバシーポリシーに基づき、適切に管理いたします。</dd>
<dt>本サービスの利用にあたっての遵守事項</dt>
<dd>お客様は、本サービスのご利用にあたり、次の行為を行ってはなりません。
<ol>
<li>第三者又は当社の財産、名誉、信用、プライバシーもしくは著作権、パブリシティー権、商標権その他の権利を侵害する行為、侵害を助長する行為又はそれらのおそれのある行為</li>
<li>第三者を誹謗中傷する行為</li>
<li>本サービスに付帯した権利を第三者に貸与、共有、譲渡等する行為</li>
<li>第三者に成りすます行為</li>
<li>個人情報及び第三者に関する情報を収集する行為</li>
<li>交際相手を誘引もしくは募集すること又はそれらに繋がる行為</li>
<li>性交渉の相手を誘引もしくは募集すること又はそれらに繋がる行為</li>
<li>メールアドレス、電話番号、住所、その他私的な連絡を可能にする情報を掲載する行為</li>
<li>児童ポルノ又は、児童ポルノに類する表現行為</li>
<li>わいせつな表現、暴力的な表現、差別的な表現、犯罪及び自殺を誘発する表現、その他公序良俗に反する内容を含むデータを公開し又は投稿する行為</li>
<li>アダルト関連サービスのサイト、その他本項各号規定の禁止行為を実施しているウェブサイト（アフィリエイト広告等により禁止行為を実施しているサイトへのリンクが貼られているサイトを含む）への直接又は間接の誘引行為</li>
<li>本サービスを選挙活動に利用すること及び、公職選挙法に抵触する行為</li>
<li>製品又はサービスの販売、販売の誘引、広告掲載その他の営業活動</li>
<li>特定の組織又は団体等への勧誘行為</li>
<li>無限連鎖講、マルチ商法、その他これらに類すると判断されうる行為及び、これらの行為への勧誘行為</li>
<li>本サービスを営利を目的として利用する行為、またはその準備を目的として利用する行為</li>
<li>画像、動画、音楽、ソフトウェアその他のファイルを違法に配信する行為及び、かかる行為の実施するサイトへと誘致する行為</li>
<li>コンピュータウィルス、その他有害なコンピュータプログラム、コード、ファイル等を公開、投稿し、又はこれらの感染又は拡散を助長する行為</li>
<li>大量のデータを送信するなど、当社のシステム又はサーバーに過度の負荷をかける行為</li>
<li>本サービスにて当社が利用者に提供する情報を無断で改ざんする行為</li>
<li>本サービスにおいて、データマイニング、ロボットなどデータ収集、抽出ツールを利用する行為</li>
<li>本サービスにてお客様に提供する情報を当社が本サービスの機能として提供する方法以外の方法で利用する行為（情報の無断転載、無断改変等を含みます）</li>
<li>本サービスの運営の妨げとなる行為又はそのおそれがあると当社が判断した行為</li>
<li>本規約に違反する行為、法令若しくは公序良俗に反する行為、それらに類する行為、又はその他の当社が不適切と判断する行為</li>
</ol>
</dd>
<dd>お客様がこれらの行為を行った場合、当社は必要と判断する措置を講じ、あわせてお客様のアカウントのはく奪を含む本サービス利用停止のための措置を講じます。その際、措置の内容、理由等をお客様にお知らせすることはありません。また、これらの措置により、お客様に損害又は不利益が生じたとしても、当社は一切責任を負わないものとします。</dd>
<dt>お客様が第三者に不利益を及ぼした場合の責任</dt>
<dd>お客様は、本サービスの利用に関連して第三者から問い合わせ、クレーム、請求、その他の紛争等があった場合、お客様の責任と費用においてこれに対応するものとします。ただし、当社に故意又は重大な過失があった場合はこの限りではありません。</dd>
<dd>本サービスの利用に関連して、お客様が当社又は第三者に損害、費用負担又は不利益を生じさせた場合、お客様はこれを賠償するものとします。</dd>
<dt>免責</dt>
<dd>当社は、本サービスがお客様の特定の目的に適合すること、期待する結果・価値・正確性・実現性を有すること及びお客様に不都合が生じないことについて、保証をするものではありません。</dd>
<dd>当社はお客様に生じた以下の損害について、その責任を負いません。
<ol>
<li>本サービスに関連して他の利用者その他の第三者と利用者との間に生じた争いによる損害</li>
<li>その他の当社の責に帰さない事由による損害</li>
</ol>
</dd>
<dd>当社がお客様に損害を与えた場合、当社はその損害を賠償いたします。但し、当社の故意又は重過失による場合を除き、賠償の範囲はお客様に現実に生じた通常且つ直接の損害に限るものとします。</dd>
<dt>本サービスの変更、中断について</dt>
<dd>当社は、お客様に対して事前にお知らせすることなく、本サービスを変更又は終了することができるものとします。</dd>
<dd>当社は、以下の事情が発生した時に、お客様に事前にお知らせすることなく、本サービスの全部又は一部の提供を中断又は停止する等の必要な措置を取ることができるものとします。
<ol>
<li>システムの定期保守や緊急保守を行う場合</li>
<li>システムに負荷が集中した場合</li>
<li>サービスの運営に支障が生じると当社が判断した場合</li>
<li>利用者のセキュリティを確保する必要が生じた場合</li>
<li>その他必要があると当社が判断した場合"</li>
</ol>
</dd>
<dd>本サービスの変更、中断、終了等によりお客様に損害又は不利益が生じたとしても、当社はその責任を負いません。</dd>
<dt>本規約の適用制限について</dt>
<dd>本規約の一部が法令に基づいて無効と判断されても、その限りにおいて適用しないものとし、その他の規定には影響を及ぼすものではありません。</dd>
<dt>本規約の解釈の仕方、お客様と当社との意見が分かれたときの取扱いについて（準拠法、管轄裁判所）</dt>
<dd>本規約は日本法に基づき解釈されるものとし、本サービスに関連して訴訟の必要が生じた場合には、その訴額に応じ東京簡易裁判所もしくは東京地方裁判所を第一審の専属的合意管轄裁判所とします。</dd>
</dl>

<h2>ポイント利用規約</h2>
<dl>
<dt>総則</dt>
<dd>ポイント規約は、当社が運営するポイントシステムと関連するサービス（以下、まとめて本規約上「ポイント」といいます）をお客様に提供するにあたっての提供条件等を定めるものです。</dd>
<dd>ポイントを利用される場合は、ポイント規約に加えて本サービスの利用規約が適用されます。したがって、ポイントを利用されるお客様は、ポイント規約及び本サービスの利用規約に同意していただく必要があります。</dd>
<dd>特段の定めのない限り、ポイント規約の用語の定義は、本サービスの利用規約と同一です。</dd>
<dt>ポイントの利用</dt>
<dd>ポイントは、お客様が本サービスの会員登録を行った場合に会員特典として利用できるサービスです。</dd>
<dd>お客様は、ポイント対象の有料サービスをご購入の際、1ポイント＝1円として計算の上、購入代金の全部に充当することができます。</dd>
<dd>お客様は、ポイントを付与された時点で即時に対象サービスの決済に使用することができます。</dd>
<dt>ポイントの付与</dt>
<dd>ポイントは、お客様がポイント対象の有料サービスをご購入の都度、所定のポイント数が付与されます。</dd>
<dd>前項の場合のほか、当社の判断によりお客様にポイントを付与する場合があります。</dd>
<dd>ポイントの対象となるか否か、ポイントの付与数若しくは付与率、及びポイント有効期限は、当社が決定するものとし、本規約又は当社所定の方法においてお客様にお知らせします。</dd>
<dt>ポイントサービス提供の条件</dt>
<dd>ポイントを利用するためには、本サービスに会員登録していただく必要があります。</dd>
<dd>お客様が本サービスの会員の地位を喪失した場合、ポイントの利用に関する一切の権利を失うこととします。なお、当社はお客様の権利の喪失に伴う損害について、一切の責任を負いません。</dd>
<dt>ポイントの制限</dt>
<dd>発生したポイントは、いかなる理由があっても換金することはできません。</dd>
<dd>一部の有料サービスでポイント付与対象外がある場合があります。</dd>
<dd>ポイントを利用してご購入できない有料サービスがある場合があります。</dd>
<dd>異なるアカウント同士のポイントの合算はできません。</dd>
<dt>ポイントの有効期限</dt>
<dd>ポイントの有効期限は、最終決済日より1年間とします。1円以上の決済が1年以上ない場合、累計のポイントは無効となります。</dd>
<dt>ポイントの照会</dt>
<dd>当社は、当社所定の方法により、ポイントの有効期限、お客様が獲得したポイント数、お客様が使用したポイント数およびポイントの残高を、お知らせいたします。</dd>
</dl>

<!--
<h2>「録画機能」利用規約</h2>
<dl>
<dt>総則</dt>
<dd>「録画機能」利用規約は、本サービスのうち、「AGARUTV」のAndroid アプリおよび iOSアプリで提供される録画機能（以下、「録画機能」といいます）を当社がお客様に提供する際のご利用条件を定めるものです。</dd>
<dd>録画機能を利用される場合は、「録画機能」利用規約に加えて、本サービスの利用規約が適用されます。したがって、録画機能を利用されるお客様は、「録画機能」利用規約及び本サービスの利用規約に同意していただく必要があります。</dd>
<dd>特段の定めのない限り、「録画機能」利用規約の用語の定義は、本サービスの利用規約と同一です。</dd>
<dt>録画機能の内容</dt>
<dd>録画機能とは、AGARUTVで配信される個々の番組のうち、お客様が指定する番組（以下、「指定番組」といいます）について、当社所定のサーバに利用者毎のID認証によりアクセスすることで、AGARUTVでの配信後も繰り返し視聴可能となるサービスをいいます。</dd>
<dd>お客様は、指定番組を当社所定のサーバ以外の場所（お客様ご自身で保有するスマートフォン端末等を含みます）に保存することはできません。</dd>
<dt>ご利用料金</dt>
<dd>録画機能には、指定できる番組容量に応じて、無料または有料の複数のプランがあり、有料の場合はプラン毎に設定された月額利用料が必要となります。</dd>
<dd>お客様は、別途当社または請求・収納代行業務を行うApple Inc.、Google Inc.（以下まとめて、「収納代行業者」といいます）が定める方法で利用料金を支払うものとします。</dd>
<dt>解約</dt>
<dd>録画機能を解約するには、当社または収納代行業者が定める方法による解約の手続を完了しなければなりません。</dd>
<dt>サーバーへのアクセス終了</dt>
<dd>当社が録画機能のサービスを終了した場合、別途当社または収納代行業者が定める期日をもって、お客様は指定番組を保存している当社所定のサーバにアクセスできなくなります。予めご了承ください。</dd>
</dl>
-->

<h2>「動画鑑定」利用規約</h2>
<dl>
<dt>総則</dt>
<dd>「動画鑑定」利用規約は、本サービスのうち、「占いTV」における動画鑑定（以下、「動画鑑定」といいます）を当社がお客様に提供する際のご利用条件を定めるものです。</dd>
<dd>動画鑑定サービスを利用される場合は、「動画鑑定」利用規約に加えて、本サービスの利用規約が適用されます。したがって、動画鑑定を利用されるお客様は、「動画鑑定」利用規約及び本サービスの利用規約に同意していただく必要があります。</dd>
<dd>特段の定めのない限り、「動画鑑定」利用規約の用語の定義は、本サービスの利用規約と同一です。</dd>
<dt>動画鑑定の内容</dt>
<dd>動画鑑定は、鑑定者による鑑定結果を動画で視聴することができるコンテンツです。 お客様は、動画鑑定において、法律等の専門知識が必要なこと、病気の診断、人の生死に関わること、ギャンブルの予想、試験の合否、紛失物の探し物等についての相談としてご利用することはできません。 また、動画鑑定は娯楽を目的としたものであり、当社および鑑定者は、その効果や、実現性、正確性等を保証するものではありません。</dd>
<dd>動画鑑定において鑑定者がお客様に提供する鑑定メッセージは、個々の鑑定者の責任において提供されるものであり、当社は鑑定メッセージついては一切の関与をいたしておりません。</dd>
<dd>動画鑑定には閲覧可能な期間が定められております。閲覧可能期限の期間につきましては、動画の視聴ページ、または、動画鑑定の購入ページをご参照ください。</dd>
<dt>動画鑑定の提供中止</dt>
<dd>動画鑑定による鑑定は、特定の鑑定者によって提供されるため当該鑑定者の健康上の事情その他のやむを得ない事由により、動画鑑定の提供が遅延または不可能となることがございます。</dd>
<dd>鑑定者の都合により動画鑑定の提供が不可能となった場合に限り、当社は当該鑑定の利用料金を返金いたします。</dd>
</dl>

<p class="note">
2019年11月21日 制定<br>
2020年4月30日 改定<br>
2020年11月30日 改定<br>
2022年3月11日 改定<br>
2023年1月6日 改定
</p>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.terms-page {
  color: $col_base_black;
  font-size: 13px;
  line-height: 1.7;
  padding: 1px 4px 30px;
  h2 {
    font-weight: bold;
    font-size: 21px;
    text-align: center;
    margin: 45px 0 30px;
  }
  dl {
    padding: 0;
    margin: 0 0 1em;
    > dt {
      font-weight: bold;
      font-size: 13px;
      margin: 1.6em 0 1em;
      counter-reset: counter;
    }
    > dd {
      margin: 0 0 1em 1.3em;
      text-indent: -1.3em;
      &::before {
        counter-increment: counter;
        content: counter(counter) ". ";
        text-align: justify;
      }
    }
  }
  ol {
    padding: 0;
    margin: 1em 0;
    counter-reset: ulist;
    > li {
      list-style: none;
      padding: 0 0 0.5em 2em;
      text-indent: 0;
      position: relative;
      &::before {
        position: absolute;
        width: 2em;
        margin-left: -2.4em;
        text-align: right;
        counter-increment: ulist;
        content: "(" counter(ulist) ") ";
      }
    }
  }
  ul {
    padding: 0;
    margin: 1em 0;
    > li {
      list-style: disc inside;
      margin: 0 0 0.5em 1.7em;
      text-indent: -1.3em;
    }
  }
  .note {}
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Help/Terms.vue